export default "/images/vendor/flag-icon-css/flags/4x3/ar.svg?2ff091f8773d0ea8640d60a3a286481b";